import { apiClient } from "../client";

export const retryPayment = (invoiceId: string) =>
  apiClient.post(`v1/invoices/${invoiceId}/retry_payment`);
